import { useRoute, useRouter } from 'vue-router';
import { ref, computed, watch, unref, isRef } from 'vue';

export function useOptions(rawArray) {
  const array = isRef(rawArray) ? rawArray : ref(rawArray);
  const route = useRoute();
  const router = useRouter();
  const limit = ref(Number(route.query.limit) || 10);
  const currentPage = ref(Number(route.query.currentPage) || 1);

  const paginationOptions = computed(() => {
    const total = unref(array)?.length ?? 0;
    return {
      limit: [10, 20],
      total,
      currentPage: currentPage.value,
    };
  });

  const getPageItems = computed(() => {
    const items = unref(array) || [];
    const start = (currentPage.value - 1) * limit.value;
    const end = currentPage.value * limit.value;
    return items.slice(start, end);
  });

  watch(
    () => paginationOptions.value.total,
    (newTotal) => {
      const lastPage = Math.max(1, Math.ceil(newTotal / limit.value));
      if (currentPage.value > lastPage) {
        currentPage.value = lastPage;
      }
    },
    { immediate: true }
  );

  function handlePagination({ currentPage: page, limit: newLimit }) {
    const limitChanged = newLimit !== limit.value;
    limit.value = newLimit;
    currentPage.value = limitChanged ? 1 : page;
    router.push({
      path: route.path,
      query: {
        limit: newLimit,
        currentPage: currentPage.value,
      },
    });
  }

  return {
    paginationOptions,
    getPageItems,
    handlePagination,
    limit,
    currentPage,
  };
}
